import axios from 'axios';

export const fetchProfileTokenizado = async () => {
  const res = await axios.get('/api/profile-tokenizado/', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access")}`
    }
  });
  return res.data;
};

export const updateCaracteristicas = async (caracteristicas) => {
  const res = await axios.put('/api/profile-tokenizado/', {
    caracteristicas
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access")}`
    }
  });
  return res.data;
};
